import CommonModal from "@/components/ui/CommonModal";
import { useModalBehavior } from "@/hooks/behaviors";
import { forwardRef, useImperativeHandle, useState } from "react";

export type VideoPreviewerRef = {
  openFilePreview: (url: string) => void;
};

export const VideoPreviewer = forwardRef<VideoPreviewerRef, {}>((_, ref) => {
  const { open, openModal, closeModal } = useModalBehavior();
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  useImperativeHandle(ref, () => {
    return {
      openFilePreview: (url) => {
        setFileUrl(url);
        openModal();
      },
    };
  });

  if (!fileUrl) return null;

  return (
    <CommonModal
      width={900}
      title="视频预览"
      open={open}
      style={{
        top: 10,
      }}
      onCancel={() => {
        closeModal();
        setFileUrl(null);
      }}
      footer={null}
    >
      <div
        style={{
          height: "75vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <video
          controls
          width="100%"
          height="100%"
          style={{ maxWidth: "100%", maxHeight: "100%" }}
          src={fileUrl}
        >
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </CommonModal>
  );
});
